import MultistepAnswers from 'custom_elements/multistep-answers'
import MultistepStep from 'custom_elements/multistep-step'
import MultistepWizard from 'custom_elements/multistep-wizard'
import MultistepWizardHipotecas from 'custom_elements/multistep-wizard-hipotecas'
import IntLocalFormat from 'custom_elements/int-local-format'
import DecLocalFormat from 'custom_elements/dec-local-format'

customElements.get('int-local-format') || customElements.define('int-local-format', IntLocalFormat, { extends: 'input' })
customElements.get('dec-local-format') || customElements.define('dec-local-format', DecLocalFormat, { extends: 'input' })
customElements.get('multistep-answers') || customElements.define('multistep-answers', MultistepAnswers)
customElements.get('multistep-step') || customElements.define('multistep-step', MultistepStep)
customElements.get('multistep-wizard') || customElements.define('multistep-wizard', MultistepWizard)
customElements.get('multistep-wizard-hipotecas') || customElements.define('multistep-wizard-hipotecas', MultistepWizardHipotecas)

